import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";

import PrevNextPaginationManager, {
    type PrevNextPaginationData,
} from "./prev-next-pagination-manager.ts";

type Props = {
    nextCursor: string | null | undefined;
    isVisible: boolean | null | undefined;
    isLoading: boolean | null | undefined;
    fetchPage: (pageCursor?: string | null | undefined) => void;
};

type DefaultProps = {
    isLoading: Props["isLoading"];
    isVisible: Props["isVisible"];
};

const btnStyle = {
    marginLeft: spacing.medium_16,
    marginRight: spacing.medium_16,
} as const;

export default class PaginationPrevNextButtons extends React.PureComponent<Props> {
    static defaultProps: DefaultProps = {
        isLoading: false,
        isVisible: true,
    };

    renderButtons: (arg1: PrevNextPaginationData) => React.ReactNode = ({
        hasNextPage,
        hasPrevPage,
        loadNextPage,
        loadPrevPage,
    }: PrevNextPaginationData) => {
        const {isVisible, isLoading} = this.props;
        if (!hasPrevPage && !hasNextPage && !isLoading) {
            return null;
        }

        return (
            <View style={[!isVisible && styles.hidden, styles.buttonContainer]}>
                <Button
                    kind="tertiary"
                    onClick={loadPrevPage}
                    disabled={!hasPrevPage}
                    style={btnStyle}
                >
                    {t`Previous`}
                </Button>
                |
                <Button
                    kind="tertiary"
                    onClick={loadNextPage}
                    disabled={!hasNextPage}
                    style={btnStyle}
                >
                    {t`Next`}
                </Button>
            </View>
        );
    };

    render(): React.ReactNode {
        const {nextCursor, fetchPage} = this.props;

        return (
            <PrevNextPaginationManager
                nextCursor={nextCursor}
                fetchPage={fetchPage}
            >
                {this.renderButtons}
            </PrevNextPaginationManager>
        );
    }
}

const styles = StyleSheet.create({
    hidden: {
        display: "none",
    },
    buttonContainer: {
        flexDirection: "row",
        alignItems: "center",
    },
});
